/* eslint semi:0 */
import i18n from 'i18n-js'
import { isString } from '../../utils/string'
import { trustHtmlString } from '../../utils/mithril'
import { queryString as qs } from '../../utils/window'
import { info, warn } from '../../application/console'
import { registerInNamespace } from '../../application/nm'
import { get as getFromPdo } from '../../application/pageDataObject'
const translations = require('exports-loader?translations=I18n.translations!../../providers/i18nProvider/generated-translations-post.js')

const FEATURE_FLAGS = {
  forceLocale: qs.forceLocale,
}

export const AVAILABLE_LOCALES = {
  EN: 'en',
  TR: 'tr',
  TH: 'th',
  ES: 'es',
  VN: 'vn',
  IT: 'it',
  ID: 'id',
  FR: 'fr',
  DE: 'de',
  BR: 'pt-BR',
}

export const DEFAULT_LOCALE = AVAILABLE_LOCALES.EN
const NO_QS_LOCALE = null

function getLocaleFromQs() {
  const qsLocale = FEATURE_FLAGS.forceLocale
  if (!qsLocale || !isString(qsLocale)) {
    return NO_QS_LOCALE
  }
  const qsLocaleUpperCase = qsLocale.toUpperCase()
  const qsLocaleValue = AVAILABLE_LOCALES[qsLocaleUpperCase]
  if (!qsLocaleValue) {
    warn('overriding nonexistent locale', qsLocaleUpperCase)
    return NO_QS_LOCALE
  }
  info('overriding locale', qsLocaleValue)
  return qsLocaleValue
}

export const locale = getLocaleFromQs() || getFromPdo('page.locale', DEFAULT_LOCALE)

export function getShortLocale(localeToShorten = locale) {
  return localeToShorten.slice(-2).toLowerCase()
}

export function localizedPath(path) {
  return locale === getFromPdo('context.defaultLocale') ? path : `/${locale}${path}`
}

export const t = i18n.t.bind(i18n)
export const l = i18n.l.bind(i18n)

export function translateTrusted(...args) {
  return trustHtmlString(t(...args))
}

Object.assign(i18n, translations, { locale, localizedPath, translateTrusted })

registerInNamespace({ i18n })
export { i18n }



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/i18nProvider/i18nProvider.js